export const CURRENCIES = {
    ALL: 'Lek',
    AFN: '&#1547;',
    ARS: '$',
    AWG: 'ƒ',
    AUD: '$',
    AZN: 'AZN',
    BSD: '$',
    BBD: '$',
    BYR: 'p.',
    BZD: 'BZ$',
    BMD: '$',
    BOB: '$b',
    BAM: 'KM',
    BWP: 'P',
    BGN: 'лв',
    BRL: 'R$',
    BND: '$',
    KHR: 'R',
    CAD: '$',
    KYD: '$',
    CLP: '$',
    CNY: '\xA5',
    COP: '$',
    CRC: '\u20A1',
    HRK: 'kn',
    CUP: '\u20B1',
    CZK: 'Kč',
    DKK: 'kr',
    DOP: 'RD$',
    XCD: '$',
    EGP: '\xA3',
    SVC: '$',
    EEK: 'kr',
    EUR: '\u20AC',
    FKP: '\xA3',
    FJD: '$',
    GHC: '\xA2',
    GIP: '\xA3',
    GTQ: 'Q',
    GGP: '\xA3',
    GYD: '$',
    HNL: 'L',
    HKD: '$',
    HUF: 'Ft',
    ISK: 'kr',
    INR: '\u20B9',
    IDR: 'Rp',
    IRR: '\uFDFC',
    IMP: '\xA3',
    ILS: '\u20AA',
    JMD: 'J$',
    JPY: '\xA5',
    JEP: '\xA3',
    KZT: 'лв',
    KPW: '\u20A9',
    KRW: '\u20A9',
    KGS: 'лв',
    LAK: '\u20AD',
    LVL: 'Ls',
    LBP: '\xA3',
    LRD: '$',
    LTL: 'Lt',
    MKD: 'ден',
    MYR: 'RM',
    MUR: '\u20A8',
    MXN: '$',
    MNT: '\u20AE',
    MZN: 'MT',
    NAD: '$',
    NPR: '\u20A8',
    ANG: 'ƒ',
    NZD: '$',
    NIO: 'C$',
    NGN: '\u20A6',
    NOK: 'kr',
    OMR: '\uFDFC',
    PKR: '\u20A8',
    PAB: 'B/.',
    PYG: 'Gs',
    PEN: 'S/.',
    PHP: '\u20B1',
    PLN: 'zł',
    QAR: '\uFDFC',
    RON: 'lei',
    RUB: 'руб',
    SHP: '\xA3',
    SAR: '\uFDFC',
    RSD: 'Дин.',
    SCR: '\u20A8',
    SGD: '$',
    SBD: '$',
    SOS: 'S',
    ZAR: 'R',
    LKR: '\u20A8',
    SEK: 'kr',
    CHF: 'CHF',
    SRD: '$',
    SYP: '\xA3',
    TWD: 'NT$',
    THB: '\u0E3F',
    TTD: 'TT$',
    TRL: '\u20A4',
    TVD: '$',
    UAH: '\u20B4',
    GBP: '\xA3',
    USD: '$',
    UYU: '$U',
    UZS: 'лв',
    VEF: 'Bs',
    VND: '\u20AB',
    YER: '\uFDFC',
    ZWD: 'Z$'
};

export const DATE_FORMATS = {
    dateTimeLongMs: '%Y-%m-%d %H:%M:%S.%SSS',
    dateTimeLong: '%Y-%m-%d %H:%M:%S',
    dateTimeShort: '%Y-%m-%d %H:%M',
    date: '%Y-%m-%d',
    timeLong: '%H:%M:%S',
    timeShort: '%H:%M'
};

export const LEFT_CURRENCY_SYMBOL_POSITION = 'onTheLeft';
